import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { IUserProfileClaim } from '@gik/calendar/models/Claim';
import ClaimedItemCard from '@gik/user-profile/components/ClaimedItemCard/ClaimedItemCard';

export interface IClaimedItemsListProps {
  items: IUserProfileClaim[];
  className?: string;
}

const blockName = 'claimed-items-list';

export default function ClaimedItemsList({ items, className }: IClaimedItemsListProps) {
  const bem = bemBlock(blockName);

  return (
    <ul className={bem(null, null, className)}>
      {items?.map(claimedItem => (
        <li className="claimed-items-list-item" key={claimedItem.id}>
          <ClaimedItemCard claimedItem={claimedItem} />
        </li>
      ))}
    </ul>
  );
}
